import { BaseTextFieldProps, TextField, Typography, Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FC, useCallback, useContext, useEffect } from 'react'
import { AppFormContext } from '../AppForm/AppForm'

export interface AppInputProps extends BaseTextFieldProps {
  field: string
}

const useStyles = makeStyles(theme => ({
  input: {
    background: '#ffffff'
  },
  root: {
    [`& fieldset`]: {
      borderRadius: '8px'
    }
  },
  characterCount: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '4px'
  }
}))

const AppInput: FC<AppInputProps> = props => {
  const appFormContext: any = useContext(AppFormContext)
  const classes = useStyles()
  const maxLength = props.inputProps?.maxLength

  const handleInputChange = useCallback(
    (inputValue: any) => {
      if (maxLength && inputValue.length > maxLength) {
        return
      }
      appFormContext.handleFormChange(props.field, inputValue)
    },
    [appFormContext, props.field, maxLength]
  )

  // register input and send default value to form object
  useEffect(() => {
    handleInputChange(props.value ?? null)
  }, [handleInputChange, props.value])

  return (
    <>
      <TextField
        className={classes.root}
        InputProps={{ className: classes.input }}
        {...props}
        onChange={e => handleInputChange(e.target.value)}
      />
      {maxLength && (
        <Box className={classes.characterCount}>
          <Typography variant="caption" color="textSecondary">
            {(props.value?.toString() || '').length} / {maxLength}
          </Typography>
        </Box>
      )}
    </>
  )
}

export default AppInput
